module.exports = "<div class=\"generic-card-header\">\n  <div class=\"header-content\">\n    <h3 class=\"generic-card-header-title\">{{title}}</h3>\n    <ng-content select=\"[corner]\"></ng-content>\n  </div>\n</div>\n<div class=\"generic-card-content\">\n <ng-content select=\"[card-content]\"></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-generic-second-card/alg-generic-second-card.component.html
// module id = ./src/app/components/molecules/alg-generic-second-card/alg-generic-second-card.component.html
// module chunks = main